/**
 * Route for `influencer-hierarchy`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { InfluencerHierarchyPage } from "../features/influencer-hierarchy/InfluencerHierarchyPage";

export const influencerHierarchyRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/influencer-hierarchy",
	component: InfluencerHierarchyPage,
});

export default influencerHierarchyRoute;
